import {
  http,
  AreasRequestPayload,
  AreasResponse,
  getAreasEndpoint,
} from "@/services";
import { AxiosRequestConfig } from "axios";
import * as z from "zod";

export const requestAreasList = <T>(
  { companyId, email }: AreasRequestPayload,
  config?: AxiosRequestConfig,
  schema?: z.Schema<T>,
) =>
  http.get<AreasResponse, T>(
    getAreasEndpoint,
    { companyId, email },
    config,
    undefined,
    schema,
  );
